import { render, staticRenderFns } from "./self.vue?vue&type=template&id=0ec54e1f"
import script from "./self.vue?vue&type=script&lang=js"
export * from "./self.vue?vue&type=script&lang=js"
import style0 from "./self.vue?vue&type=style&index=0&id=0ec54e1f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_css-loader@6.5.0_webpack@5.105.4_postcss@8._43d1d126ebb10e2c441c66a2d5e08766/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports